import React from 'react';
import { Address } from '../../../models';

interface AddressCardProps {
  address: Address;
}

function AddressCard({ address }: AddressCardProps) {
  return (
    <div className="w-full md:w-1/2 p-4">
      <div className="rounded bg-white shadow h-44 p-8 flex flex-col text-text-black leading-8">
        <span>
          {address?.address1} {address?.address2}
        </span>
        <span>
          {address?.municipality}, {address?.state}
        </span>
        <span>{address?.country}</span>
      </div>
    </div>
  );
}

export default AddressCard;
